var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Styles
import { getLabelStyles } from './getLabelStyles';
// Utils
import styled from 'styled-components';
export var Label = styled.label.attrs(function (_a) {
    var htmlFor = _a.htmlFor, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    return ({
        htmlFor: htmlFor,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var truncateText = _a.truncateText, theme = _a.theme, size = _a.size, required = _a.required, _b = _a.styleVariant, styleVariant = _b === void 0 ? 'bold' : _b, contentColor = _a.contentColor;
    return getLabelStyles({ truncateText: truncateText, theme: theme, size: size, required: required, styleVariant: styleVariant, contentColor: contentColor });
});
var templateObject_1;
//# sourceMappingURL=Label.js.map